import { useMemo, useState, useEffect } from "react";
import { SUBDOMAIN } from "../../assets/meta/meta";
import { useUserStore } from "../../store/store";

export interface PGModule {
  id: number;
  code: "hecto" | "nicepay" | "toss";
  label: string;
}

/**
 * PG 모듈 목록을 사이트 설정 기반으로 생성하고, 첫 번째 모듈을 기본 선택합니다.
 */
export function usePGModules() {
  const [sitePaymentKeys] = useUserStore((state) => [state.sitePaymentKeys]);

  const pgModules = useMemo<PGModule[]>(() => {
    const modules: PGModule[] = [];
    const site = sitePaymentKeys.find((s: any) => s.client_id === SUBDOMAIN);
    if (!site) return modules;
    if (site.use_hecto) modules.push({ id: 3, code: "hecto", label: "헥토페이" });
    if (site.use_nicepay) modules.push({ id: 2, code: "nicepay", label: "나이스페이" });
    if (site.use_toss) modules.push({ id: 1, code: "toss", label: "토스" });
    return modules;
  }, [sitePaymentKeys]);

  const [selectedPG, setSelectedPG] = useState<PGModule | null>(null);

  useEffect(() => {
    if (pgModules.length > 0) {
      setSelectedPG(pgModules[0]);
    }
  }, [pgModules]);

  return { pgModules, selectedPG, setSelectedPG };
}
